import { useTranslation } from 'react-i18next';

import { Table } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { SearchProductsResponse } from '@interfaces/products.interface';

import PaginationRow from '../PaginationRow';
import ProductTableRow from '../ProductTableRow';
import classes from './ProductTable.module.css';

interface ProductTableProps {
  showConfColumn: boolean;
  products: SearchProductsResponse;
  page: number;
  pageLength: number;
  marketCategory: string;
}

export default function ProductTable({
  showConfColumn = false,
  page,
  pageLength,
  products,
  marketCategory,
}: ProductTableProps) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 62em)');

  const totalPages = products && Math.ceil(products.totalCount / pageLength);

  return (
    <>
      <Table.ScrollContainer minWidth={800}>
        <Table withColumnBorders className={classes.productsTable}>
          <Table.Thead>
            <Table.Tr style={{ backgroundColor: '#ddd' }}>
              <Table.Th>{t('products.product')}</Table.Th>
              <Table.Th>
                {marketCategory === 'Cosmetico' ? (
                  t('products.function')
                ) : (
                  <>
                    {t('products.application')}/
                    <br />
                    {t('products.reactivity')}
                  </>
                )}
              </Table.Th>
              {showConfColumn && <Table.Th>{t('products.conf')}</Table.Th>}
              {!isMobile && <Table.Th>{t('products.details')}</Table.Th>}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {products?.products.map((product, index) => (
              <ProductTableRow
                product={product}
                key={index}
                showConfColumn={showConfColumn}
                isMobile={isMobile}
                marketCategory={marketCategory}
              />
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
      {products && products.products.length > 0 && (
        <PaginationRow
          page={page}
          pageLength={pageLength}
          totalPages={totalPages!}
        />
      )}
    </>
  );
}
